export default __webpack_public_path__ + "static/media/downloadIcon.0176bea7.svg";